import {
  IconAccountProfile,
  IconCouponStroke,
  IconCreditCard,
  IconEdit,
  IconInformationStroke,
  IconMembership,
  IconReturns,
  IconShipping,
  IconShippingTruck,
  IconCheckFill,
  IconErrorFill,
  IconInformationFill,
  IconStorefront,
  IconVirtualOutfitting,
  IconWarningFill,
} from '@rei/cedar';

const icons = {
  IconAccountProfile,
  IconCouponStroke,
  IconCreditCard,
  IconEdit,
  IconInformationStroke,
  IconMembership,
  IconReturns,
  IconShipping,
  IconShippingTruck,
  IconCheckFill,
  IconErrorFill,
  IconInformationFill,
  IconStorefront,
  IconVirtualOutfitting,
  IconWarningFill,
};

export function useIcons(key: string) {
  return icons[key];
};
